import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getAuditLogSearch = get('inventory.components.auditLogSearch');

export const getAuditLogSearchQuery = createSelector(
  getAuditLogSearch,
  get('query')
);
